import * as BlobMethods from './blob';

export default {
	...BlobMethods,
};
